import { AXIOS_ENV_URL } from "@/utils/env";

export const baseURL =
  window.location.origin === "http://localhost:9999"
    ? AXIOS_ENV_URL.development
    : window.location.origin;

/**gtl域名修改**/
export const gtlURL = {
  // "https://gtl-boe-n.bytedance.net"
  development:window.atob('aHR0cHM6Ly9ndGwtYm9lLW4uYnl0ZWRhbmNlLm5ldA=='),
  // https://gtl.bytedance.com
  production: window.atob('aHR0cHM6Ly9ndGwuYnl0ZWRhbmNlLmNvbQ=='),
};
